import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import SinemDoctorForm from "./sinem/SinemDoctorForm";
import SinemPatientForm from "./sinem/SinemPatientForm";
import ScintiEstDoctorForm from "./scinti-est/ScintiEstDoctorForm";
import ScintiEstPatientForm from "./scinti-est/ScintiEstPatientForm";
import CmnBriveDoctorForm from "./cmn-brive/CmnBriveDoctorForm";
import CmnBrivePatientForm from "./cmn-brive/CmnBrivePatientForm";
import Cs2sDoctorForm from "./cs2s/Cs2sDoctorForm";
import Cs2sPatientForm from "./cs2s/Cs2sPatientForm";

const AppointmentRequest = () => {
  const location = useLocation();

  const [clientName, setClientName] = useState("");
  const contactForms = useRef<{ [key: string]: React.ElementType }>({
    sinemPatient: SinemPatientForm,
    sinemDoctor: SinemDoctorForm,
    scintiEstPatient: ScintiEstPatientForm,
    scintiEstDoctor: ScintiEstDoctorForm,
    cmnBrivePatient: CmnBrivePatientForm,
    cmnBriveDoctor: CmnBriveDoctorForm,
    cs2sPatient: Cs2sPatientForm,
    cs2sDoctor: Cs2sDoctorForm,
  }).current;

  useEffect(() => {
    const search = location.search;
    const query = new URLSearchParams(search);
    const client = query.get("client") || "";
    setClientName(client);
  }, [location.search]);

  const _getAppointmentForm = (): React.ElementType | null => {
    const form = contactForms[clientName];

    return form;
  };

  const AppointmentForm = _getAppointmentForm();

  return AppointmentForm ? <AppointmentForm /> : <h1>Not found</h1>;
};

export default AppointmentRequest;
